import { render } from "./HeroiconsOutlineBriefcase.vue?vue&type=template&id=5e2a657e"
const script = {}

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineBriefcase.vue"]])

export default __exports__